export type Maybe<T> = T;
export type InputMaybe<T> = T;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A mapping of language to translation. Example: '{ "DE": "Backwaren"}' */
  CategoryI18N: { input: unknown; output: unknown; }
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: string; output: string; }
  Decimal: { input: unknown; output: unknown; }
  /** A scalar that can represent any JSON value. */
  JSON: { input: any; output: any; }
  /** A scalar that can represent any JSON Object value. */
  JSONObject: { input: unknown; output: unknown; }
  /**
   * ISO 8601 time without timezone.
   * Allows for the nanosecond precision and optional leap second representation.
   * Format: %H:%M:%S%.f
   *
   * # Examples
   *
   * * `08:59:60.123`
   */
  NaiveTime: { input: unknown; output: unknown; }
  /**
   * A UUID is a unique 128-bit number, stored as 16 octets. UUIDs are parsed as
   * Strings within GraphQL. UUIDs are used to assign unique identifiers to
   * entities without requiring a central allocating authority.
   *
   * # References
   *
   * * [Wikipedia: Universally Unique Identifier](http://en.wikipedia.org/wiki/Universally_unique_identifier)
   * * [RFC4122: A Universally Unique Identifier (UUID) URN Namespace](http://tools.ietf.org/html/rfc4122)
   */
  UUID: { input: string; output: string; }
};

export type AvailableSpaceConfiguration = {
  configuration: SpaceConfiguration;
  dimensions: OutputDimensions;
  numSpaces: Scalars['Int']['output'];
  spaces: Array<Space>;
};

export type B2BNotificationRecipient = {
  email: Scalars['String']['output'];
  ended: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  opened: Scalars['Boolean']['output'];
  started: Scalars['Boolean']['output'];
};

export type B2BNotificationRecipientInput = {
  email: Scalars['String']['input'];
  ended: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  opened: Scalars['Boolean']['input'];
  started: Scalars['Boolean']['input'];
};

export type B2BNotificationRecipientPage = {
  nodes: Array<B2BNotificationRecipient>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type B2BlockReservationSubtype = {
  createdByUserId?: Maybe<User>;
  organization: Organization;
};

export type B2CcheckoutCreateInput = {
  category: SpaceCategory;
  hubId: Scalars['UUID']['input'];
};

export type B2ClockReservationSubtype = {
  b2CLockSession: B2ClockSession;
  user: User;
};

export type B2ClockSession = {
  /** The session's single non-terminal payment, if one exists. */
  activePayment?: Maybe<B2ClockSessionPayment>;
  /** Total amount collected in cents. */
  amountCollected: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentCost?: Maybe<Scalars['Decimal']['output']>;
  dailyCeiling: Scalars['Decimal']['output'];
  finalAmount?: Maybe<Scalars['Int']['output']>;
  hourlyRate: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
  /** Terminal payments for the session, ordered from oldest to newest. */
  pastPayments: Array<B2ClockSessionPayment>;
  paymentStatus?: Maybe<B2ClockSessionPaymentStatus>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rentalEndedAt?: Maybe<Scalars['DateTime']['output']>;
  rentalStartedAt?: Maybe<Scalars['DateTime']['output']>;
  spaceCategory: SpaceCategory;
  startFee: Scalars['Decimal']['output'];
  status: B2ClockSessionStatus;
  updatedAt: Scalars['DateTime']['output'];
  weekCeiling: Scalars['Decimal']['output'];
};

export type B2ClockSessionEndInput = {
  b2CSessionId: Scalars['UUID']['input'];
};

export type B2ClockSessionFeeEstimateInput = {
  until: Scalars['DateTime']['input'];
};

export type B2ClockSessionPayment = {
  /** Amount the Stripe PaymentIntent was created to process, in cents. */
  amount: Scalars['Int']['output'];
  /** Amount currently available to capture in Stripe, in cents. */
  amountCapturable: Scalars['Int']['output'];
  /** Amount received by Stripe, in cents. */
  amountReceived: Scalars['Int']['output'];
  b2CLockSession: B2ClockSession;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /**
   * Stripe secret to complete a payment.
   * If this value is `None` run `b2c_lock_session_payment_continue` to
   * advance the state of the session payment.
   */
  paymentIntentSecret?: Maybe<Scalars['String']['output']>;
  stripeStatus?: Maybe<StripePaymentIntentStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum B2ClockSessionPaymentStatus {
  Completed = 'COMPLETED',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE'
}

export enum B2ClockSessionStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  RentalEnded = 'RENTAL_ENDED',
  RentalStarted = 'RENTAL_STARTED'
}

export type B2CsessionBy = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  reservationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Brand = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  logo: CloudflareImage;
  name: Scalars['String']['output'];
  organization: Organization;
  products: ProductPage;
  updatedAt: Scalars['DateTime']['output'];
};


export type BrandProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  orderBy?: Array<ProductOrderByEntry>;
  pagination?: PaginationInput;
};

export type BrandCreateInput = {
  imageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type BrandFilter = {
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type BrandOrderByEntry = {
  field: BrandOrderByField;
  ordering: Ordering;
};

export enum BrandOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type BrandPage = {
  nodes: Array<Brand>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type BrandUpdateInput = {
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Bundle = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: BundleEventPage;
  hub?: Maybe<Hub>;
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  organization: Organization;
  packages: PackagePage;
  status: BundleStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
  warehouse: Warehouse;
};


export type BundleEventsArgs = {
  pagination?: PaginationInput;
};


export type BundlePackagesArgs = {
  pagination?: PaginationInput;
};

export type BundleCancelInput = {
  bundleId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};

export type BundleCollectInput = {
  bundleId: Scalars['UUID']['input'];
  reservationId: Scalars['UUID']['input'];
};

export type BundleCompartmentReturnInput = {
  bundleId: Scalars['UUID']['input'];
  /** Nonempty, unique package IDs belonging to this Bundle and compartment. */
  packageIds: Array<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reservationId: Scalars['UUID']['input'];
};

export type BundleCreateInput = {
  /** Defaults to the authenticated user. Operators may create for another user. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  warehouseId: Scalars['UUID']['input'];
};

export type BundleDestinationSetInput = {
  bundleId: Scalars['UUID']['input'];
  hubId: Scalars['UUID']['input'];
};

export type BundleEvent = {
  actor: User;
  bundleId: Scalars['UUID']['output'];
  data: Scalars['JSON']['output'];
  recordedAt: Scalars['DateTime']['output'];
  schemaVersion: Scalars['Int']['output'];
  sequence: Scalars['Int']['output'];
};

export type BundleEventPage = {
  nodes: Array<BundleEvent>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type BundleFilter = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  orgId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<BundleStatus>;
  /** Matches any of the listed statuses. Combined with `status` when both are set. */
  statuses?: InputMaybe<Array<BundleStatus>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  warehouseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type BundleInput = {
  bundleId: Scalars['UUID']['input'];
};

export type BundlePackagesReturnInput = {
  bundleId: Scalars['UUID']['input'];
  packageIds: Array<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type BundlePage = {
  nodes: Array<Bundle>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum BundleStatus {
  Cancelled = 'CANCELLED',
  Collected = 'COLLECTED',
  Confirmed = 'CONFIRMED',
  Forming = 'FORMING',
  PartiallyCollected = 'PARTIALLY_COLLECTED',
  ReadyForPickup = 'READY_FOR_PICKUP'
}

export type Capacity = {
  amount: Scalars['Int']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  organizationId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CapacityConnection = {
  /** A list of edges. */
  edges: Array<CapacityEdge>;
  /** A list of nodes. */
  nodes: Array<Capacity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CapacityCreateInput = {
  amount: Scalars['Int']['input'];
  hubId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

/** An edge in a connection. */
export type CapacityEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Capacity;
};

export type CapacityFilter = {
  amount?: InputMaybe<U16Filter>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CapacityOrderByEntry = {
  field: CapacityOrderByField;
  ordering: Ordering;
};

export enum CapacityOrderByField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  OrganizationId = 'ORGANIZATION_ID',
  UpdatedAt = 'UPDATED_AT'
}

export type CapacityPage = {
  nodes: Array<Capacity>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CapacityUpdateInput = {
  amount: Scalars['Int']['input'];
  id: Scalars['UUID']['input'];
};

export type Category = {
  createdAt: Scalars['DateTime']['output'];
  i18N: Scalars['CategoryI18N']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  products: ProductPage;
  updatedAt: Scalars['DateTime']['output'];
};


export type CategoryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  orderBy?: Array<ProductOrderByEntry>;
  pagination?: PaginationInput;
};

export type CategoryCreateInput = {
  i18N?: InputMaybe<Scalars['CategoryI18N']['input']>;
  name: Scalars['String']['input'];
};

export type CategoryFilter = {
  name?: InputMaybe<StringFilter>;
};

export type CategoryOrderByEntry = {
  field: CategoryOrderByField;
  ordering: Ordering;
};

export enum CategoryOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type CategoryPage = {
  nodes: Array<Category>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CategoryUpdateInput = {
  i18N?: InputMaybe<Scalars['CategoryI18N']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClickNCollectReservation = Reservation & {
  activePickup?: Maybe<Pickup>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
};


export type ClickNCollectReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};

export type ClickNCollectReservationCreateInput = {
  spaceId: Scalars['UUID']['input'];
};

export type CloudflareImage = {
  id: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};


export type CloudflareImageVariantArgs = {
  variant: Variant;
};

export type CnCHubSettings = {
  createdAt: Scalars['DateTime']['output'];
  defaultPickupExpirationMinutes?: Maybe<Scalars['Int']['output']>;
  hub: Hub;
  id: Scalars['UUID']['output'];
  organization: Organization;
  updatedAt: Scalars['DateTime']['output'];
};

export type CnCHubSettingsPage = {
  nodes: Array<CnCHubSettings>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CoreReservation = Reservation & {
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
};


export type CoreReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};

export type Credit = {
  bundleId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  events: CreditEventPage;
  grantedBy: User;
  id: Scalars['UUID']['output'];
  status: CreditStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
};


export type CreditEventsArgs = {
  pagination?: PaginationInput;
};

export type CreditBalance = {
  available: Scalars['Int']['output'];
  consumed: Scalars['Int']['output'];
  reserved: Scalars['Int']['output'];
};

export type CreditEvent = {
  actor: User;
  creditId: Scalars['UUID']['output'];
  data: Scalars['JSON']['output'];
  recordedAt: Scalars['DateTime']['output'];
  schemaVersion: Scalars['Int']['output'];
  sequence: Scalars['Int']['output'];
};

export type CreditEventPage = {
  nodes: Array<CreditEvent>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CreditFilter = {
  status?: InputMaybe<CreditStatus>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreditGrantInput = {
  quantity: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

export type CreditPage = {
  nodes: Array<Credit>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum CreditStatus {
  Available = 'AVAILABLE',
  Consumed = 'CONSUMED',
  Reserved = 'RESERVED'
}

export type Customer = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerBy = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateInput = {
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CustomerFilter = {
  email?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<StringFilter>;
};

export type CustomerOrderByEntry = {
  field: CustomerOrderByField;
  ordering: Ordering;
};

export enum CustomerOrderByField {
  Email = 'EMAIL',
  Id = 'ID',
  PhoneNumber = 'PHONE_NUMBER'
}

export type CustomerPage = {
  nodes: Array<Customer>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DeleteResult = DeleteResultFailure | DeleteResultSuccess;

export type DeleteResultFailure = {
  reason: Scalars['String']['output'];
};

export type DeleteResultSuccess = {
  id: Scalars['UUID']['output'];
};

export type GrantUnlock = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  unlockRequest: UnlockRequest;
  updatedAt: Scalars['DateTime']['output'];
  utilizationGrant: UtilizationGrant;
};

export type Hub = {
  availableConfigurations: Array<AvailableSpaceConfiguration>;
  capacities: CapacityPage;
  id: Scalars['UUID']['output'];
  meta?: Maybe<HubMeta>;
  products: HubProductPage;
  /**
   * Returns a `HubRaffle` which contains all `RaffleReservations` that are active for this hub
   * If the `Raffle` is not ready yet this will return `None`
   */
  raffle?: Maybe<HubRaffle>;
  /** Slug of the Hub, used in MQTT topics, unique. */
  slug: Scalars['String']['output'];
  sncOrders: SncOrderPage;
  sncProducts: SncProductPage;
  spaceConfigurations: Array<SpaceConfiguration>;
  spaces: Array<Space>;
  status: HubStatus;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['String']['output']>;
};


export type HubCapacitiesArgs = {
  filter?: InputMaybe<CapacityFilter>;
  orderBy?: Array<CapacityOrderByEntry>;
  pagination?: PaginationInput;
};


export type HubProductsArgs = {
  filter?: InputMaybe<HubProductFilter>;
  orderBy?: Array<HubProductOrderByEntry>;
  pagination?: PaginationInput;
};


export type HubSncOrdersArgs = {
  filter?: InputMaybe<SncOrderFilter>;
  orderBy?: Array<SncOrderOrderByEntry>;
  pagination?: PaginationInput;
};


export type HubSncProductsArgs = {
  filter?: InputMaybe<SncProductFilter>;
  orderBy?: Array<SncProductOrderByEntry>;
  pagination?: PaginationInput;
};

export type HubCapacityOverview = {
  /** The mimimum amount of b2c usage the `Hub` must guarantee */
  b2CCapacityMin: Scalars['Int']['output'];
  /** Currently utilized b2c capacity */
  b2CCapacityUtilized: Scalars['Int']['output'];
  /** The total sum of all fixed capacity allocated, it doesn't matter if its used or not */
  fixedCapacity: Scalars['Int']['output'];
  flexCapacityAvailable: Scalars['Int']['output'];
  /** Active reservations with `flex = true` */
  flexCapacityUtilized: Scalars['Int']['output'];
  sharedCapacity: Scalars['Int']['output'];
  sharedCapacityAvailable: Scalars['Int']['output'];
  totalSpaces: Scalars['Int']['output'];
};

export type HubConnection = {
  /** A list of edges. */
  edges: Array<HubEdge>;
  /** A list of nodes. */
  nodes: Array<Hub>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubCreateInput = {
  slug: Scalars['String']['input'];
  spaces?: Array<SpaceCreateBase>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type HubEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Hub;
};

export type HubFilter = {
  /** If specified only returns hubs that have a `HubMeta` field */
  meta?: InputMaybe<HubMetaFilter>;
  slug?: InputMaybe<StringFilter>;
  /** Set this to only return `Hub` that don't have a `HubMeta` field */
  unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HubMeta = {
  /** Additional address information */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  b2CCapacityMin: Scalars['Int']['output'];
  capacityOverview: HubCapacityOverview;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  hub?: Maybe<Hub>;
  id: Scalars['UUID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationCapacity: HubOrganizationCapacity;
  postalCode: Scalars['String']['output'];
  serviceProviders: Array<Organization>;
  /** Array of active services on this hub */
  services: Array<HubService>;
  street: Scalars['String']['output'];
};


export type HubMetaOrganizationCapacityArgs = {
  organizationId: Scalars['UUID']['input'];
};

export type HubMetaBy = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type HubMetaConnection = {
  /** A list of edges. */
  edges: Array<HubMetaEdge>;
  /** A list of nodes. */
  nodes: Array<HubMeta>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HubMetaCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  hubId: Scalars['UUID']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  postalCode: Scalars['String']['input'];
  services: Array<HubService>;
  street: Scalars['String']['input'];
};

/** An edge in a connection. */
export type HubMetaEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: HubMeta;
};

export type HubMetaFilter = {
  name?: InputMaybe<StringFilter>;
  /** Filter HubMeta by the owner organization */
  organizationId?: InputMaybe<UuidFilter>;
  /** Find HubMeta's which have any of the given service providers */
  serviceProviders?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type HubMetaOrderByEntry = {
  field: HubMetaOrderByField;
  ordering: Ordering;
};

export enum HubMetaOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type HubMetaPage = {
  nodes: Array<HubMeta>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type HubMetaUpdateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<HubService>>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type HubOrderByEntry = {
  field: HubOrderByField;
  ordering: Ordering;
};

export enum HubOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

/** Data about Capacity usage for a specific Organization */
export type HubOrganizationCapacity = {
  fixedAvailable: Scalars['Int']['output'];
  fixedCapacity: Scalars['Int']['output'];
  fixedUtilized: Scalars['Int']['output'];
  flexUtilized: Scalars['Int']['output'];
};

export type HubPage = {
  nodes: Array<Hub>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type HubProduct = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  organization: Organization;
  priceAmount: Scalars['Int']['output'];
  product: Product;
  productInstances: ProductInstancePage;
  stock: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type HubProductProductInstancesArgs = {
  filter?: InputMaybe<ProductInstanceFilter>;
  orderBy?: Array<ProductInstanceOrderByEntry>;
  pagination?: PaginationInput;
};

export type HubProductCreateInput = {
  hubId: Scalars['UUID']['input'];
  /** Price in cents to override the default price of the product */
  hubPriceAmount?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
};

/**
 * The result of a delete operation on a `HubProduct`
 * - Successfully deleted
 * - Deactivated the HubProduct instead
 * - Non trivial error encountered while attempting to delete
 */
export type HubProductDeleteResult = DeleteResultFailure | DeleteResultSuccess | HubProduct;

export type HubProductFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<ProductFilter>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
};

export type HubProductOrderByEntry = {
  field: HubProductOrderByField;
  ordering: Ordering;
};

export enum HubProductOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type HubProductPage = {
  nodes: Array<HubProduct>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type HubProductReactivateInput = {
  hubProductId: Scalars['UUID']['input'];
};

export type HubProductUpdateInput = {
  hubPriceAmount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type HubRaffle = {
  ready: Scalars['Boolean']['output'];
  reservations: Array<RaffleReservation>;
};

export enum HubService {
  ClickNCollect = 'CLICK_N_COLLECT',
  InstantBuy = 'INSTANT_BUY',
  LockB2B = 'LOCK_B2B',
  LockB2C = 'LOCK_B2C',
  Onedelivery = 'ONEDELIVERY',
  Raffle = 'RAFFLE',
  ShopNCollect = 'SHOP_N_COLLECT'
}

export type HubSettingsCreateInput = {
  defaultPickupExpirationMinutes?: InputMaybe<Scalars['Int']['input']>;
  hubId: Scalars['UUID']['input'];
};

export type HubSettingsFilter = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type HubSettingsOrderByEntry = {
  field: HubSettingsOrderByField;
  ordering: Ordering;
};

export enum HubSettingsOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type HubSettingsUpdateInput = {
  defaultPickupExpirationMinutes?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export enum HubStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type ImageUpload = {
  id: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type InstantBuy = {
  amount: Scalars['Int']['output'];
  clientReferenceId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  lineItems: Array<LineItem>;
  organization: Organization;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  status: InstantBuyStatus;
  stripeClientSecret: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type InstantBuyBy = {
  clientReferenceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type InstantBuyCreateInput = {
  clientReferenceId: Scalars['String']['input'];
  hubId: Scalars['UUID']['input'];
  hubProductIds: Array<Scalars['UUID']['input']>;
  returnUrl: Scalars['String']['input'];
};

export type InstantBuyFilter = {
  amount?: InputMaybe<U16Filter>;
  createdAt?: InputMaybe<TimestampFilter>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  productInstance?: InputMaybe<ProductInstanceFilter>;
  status?: InputMaybe<InstantBuyStatus>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InstantBuyOrderByEntry = {
  field: InstantBuyOrderByField;
  ordering: Ordering;
};

export enum InstantBuyOrderByField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type InstantBuyPage = {
  nodes: Array<InstantBuy>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum InstantBuyStatus {
  /** The instant buy session has been processed by the reconciliation loop and closed */
  Closed = 'CLOSED',
  /** The InstantBuy is currently open for checkout in stripe */
  Open = 'OPEN',
  /**
   * The instant buy has been captured by stripe, officially becoming a purchase for the
   * user/guest and can now be retrieved
   */
  Purchased = 'PURCHASED'
}

export enum IntegrationType {
  Api = 'API',
  ShopNCollect = 'SHOP_N_COLLECT',
  Thalia = 'THALIA'
}

export type Invitation = {
  authMode: InvitationAuthMode;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inviterId: Scalars['UUID']['output'];
  inviterName: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  organizationName: Scalars['String']['output'];
  role?: Maybe<OrganizationRole>;
  status: InvitationStatus;
};

export enum InvitationAuthMode {
  SignIn = 'SIGN_IN',
  SignUp = 'SIGN_UP'
}

export type InvitationFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<InvitationStatus>;
};

export type InvitationOrderByEntry = {
  field: InvitationOrderByField;
  ordering: Ordering;
};

export enum InvitationOrderByField {
  ExpiresAt = 'EXPIRES_AT',
  Id = 'ID',
  Status = 'STATUS'
}

export type InvitationPage = {
  nodes: Array<Invitation>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LineItem = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  instantBuy: InstantBuy;
  organization: Organization;
  priceAmount: Scalars['Int']['output'];
  productInstance: ProductInstance;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LineItemRetrieveInput = {
  lineItemId: Scalars['UUID']['input'];
};

export enum LockGrantType {
  Anonymous = 'ANONYMOUS',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type LockReservation = Reservation & {
  contentNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedByGrant?: Maybe<UtilizationGrant>;
  deactivatedByUser?: Maybe<User>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  service: Service;
  space: Space;
  startedAt: Scalars['DateTime']['output'];
  subtype: LockReservationSubtype;
  unlockRequests: UnlockRequestPage;
  utilizationGrants: UtilizationGrantPage;
};


export type LockReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};


export type LockReservationUtilizationGrantsArgs = {
  filter?: InputMaybe<UtilizationGrantFilter>;
  orderBy?: Array<UtilizationGrantOrderByEntry>;
  pagination?: PaginationInput;
};

export type LockReservationCreateInput = {
  spaceId: Scalars['UUID']['input'];
};

export type LockReservationFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  subtype: LockReservationType;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type LockReservationOrderByEntry = {
  field: LockReservationOrderByField;
  ordering: Ordering;
};

export enum LockReservationOrderByField {
  Id = 'ID',
  StartedAt = 'STARTED_AT'
}

export type LockReservationPage = {
  nodes: Array<LockReservation>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type LockReservationSubtype = B2BlockReservationSubtype | B2ClockReservationSubtype;

export enum LockReservationType {
  B2B = 'B2B',
  B2C = 'B2C'
}

export type LockReservationUnlockInput = {
  lockReservationId: Scalars['UUID']['input'];
};

export type Mutation = {
  /** Start a B2B lock rental */
  b2BLockReservationCreate: Scalars['UUID']['output'];
  /** End a B2B lock rental. */
  b2BLockReservationDeactivate: Scalars['UUID']['output'];
  b2CLockSessionCreate: B2ClockSession;
  b2CLockSessionEnd: B2ClockSession;
  /**
   * Advance the state of a B2C Lock Session Payment.
   * The B2CLockSessionPayment type can be void of any actual stripe payment intent
   * in some rare occurrences like mid-air crashes or a Stripe API outage.
   * If the session itself is still awaiting payment or requires a balance
   * payment this endpoint will continue the payment process.
   * For completed/closed sessions a dangling session payment is acceptable
   * and will be ignored.
   */
  b2CLockSessionPaymentContinue: B2ClockSessionPayment;
  b2bNotificationRecipientDelete: Scalars['Boolean']['output'];
  b2bNotificationRecipientSave: B2BNotificationRecipient;
  brandCreate: Brand;
  brandDelete: DeleteResult;
  brandUpdate: Brand;
  bundleCancel: Bundle;
  bundleCollect: UnlockRequest;
  /**
   * Employee removal from a compartment for transport back to the source warehouse.
   * Receipt at the warehouse is confirmed separately with packageReturnsReceive.
   */
  bundleCompartmentReturnToWarehouse: UnlockRequest;
  /** Reserves Credit and freezes the exact package contents atomically. */
  bundleConfirm: Bundle;
  bundleCreate: Bundle;
  bundleDestinationSet: Bundle;
  bundleDispatchToHub: Bundle;
  bundlePackagesReturnToWarehouse: Bundle;
  bundleReadyForPickup: Bundle;
  capacityCreate: Capacity;
  capacityDelete: Scalars['UUID']['output'];
  capacityUpdate: Capacity;
  categoryCreate: Category;
  categoryDelete: DeleteResult;
  categoryUpdate: Category;
  clickNCollectReservationCreate: Scalars['UUID']['output'];
  clickNCollectReservationDeactivate: ClickNCollectReservation;
  cncHubSettingsCreate: CnCHubSettings;
  cncHubSettingsUpdate: CnCHubSettings;
  coreReservationCreate: CoreReservation;
  coreReservationDeactivate: CoreReservation;
  creditGrant: Array<Credit>;
  customerCreate: Customer;
  hubCreate: Hub;
  hubMetaCreate: HubMeta;
  hubMetaUpdate: HubMeta;
  hubProductCreate: HubProduct;
  /**
   * Deletes a HubProduct.
   * If the HubProduct has linked `ProductInstance` entities it will get deactivated.
   * If there are `ProductInstance` currently in the `Hub` the operation will fail.
   */
  hubProductDelete: HubProductDeleteResult;
  hubProductReactivate: HubProduct;
  hubProductUpdate: HubProduct;
  instantBuyClaim: InstantBuy;
  instantBuyCreate: InstantBuy;
  instantBuyDelete: DeleteResult;
  lineItemRetrieve: UnlockRequest;
  /**
   * Unlock a Lock reservation. Can be both B2B or B2C.
   * This endpoint is meant for the owner of the rental.
   * For guests or granted access use the `UtilizationGrant` API.
   */
  lockReservationUnlock: UnlockRequest;
  lockUtilizationGrantCreate: UtilizationGrant;
  lockUtilizationGrantDeactivate: UtilizationGrant;
  /**
   * Invite an anonymous user (by email) to open this reservation's lock.
   * Generates a secure access token and emails an invite link via Hermes.
   */
  lockUtilizationGrantInviteAnonymous: UtilizationGrant;
  lockUtilizationGrantUpdate: UtilizationGrant;
  onedeliveryReservationCreate: Scalars['UUID']['output'];
  openingHoursCreate: OpeningHours;
  openingHoursDelete: Scalars['UUID']['output'];
  openingHoursUpdate: OpeningHours;
  orderCreate: Order;
  /**
   * Deletes an `Order`.
   * You cannot delete an `Order` that is sourced from ShopAndCollect
   */
  orderDelete: DeleteResult;
  /**
   * Creates a new `OrderItem`.
   * In case of a collision on `input.external_id` this will execute an update instead.
   */
  orderItemCreate: OrderItem;
  /**
   * Deletes an `OrderItem`.
   * You cannot delete an `OrderItem` that is linked to a `Pickup`,
   * if this is the case use `orderItemRemove` first.
   */
  orderItemDelete: DeleteResult;
  /**
   * Removes an `OrderItem` from a `Pickup`.
   * This will also set `filled_with` to `None` on the `OrderItem`,
   * if you first need to physically remove the `OrderItem` from the `Pickup` you
   * should call `pickupUnlock` first.
   */
  orderItemRemove: OrderItem;
  organizationLogoCreate: ImageUpload;
  organizationScopesSet: Organization;
  organizationUpdate: Organization;
  packageCreate: Package;
  packageFill: PackageFillResult;
  packageReturnsReceive: Array<Package>;
  packageUserUnlink: Package;
  pharmacyHubCreate: PharmacyHub;
  pharmacyHubDelete: Scalars['UUID']['output'];
  pharmacyHubUpdate: PharmacyHub;
  /**
   * Retrieves a `Pickup` as a `Customer`. This transitions the `Pickup` to `COLLECTING`.
   * After 20min the `Pickup` will be `COLLECTED` and the `Customer` will be notified.
   * Within the timeframe this function can be called multiple times if the `UnlockRequest`
   * has had issues.
   */
  pickupCollect: Scalars['UUID']['output'];
  /**
   * Confirm a `Pickup` to be collected by the `Customer`.
   * This will send out a nofitication email/sms to the `Customer`.
   * You can't confirm a `Pickup` without any `OrderItems` filled.
   */
  pickupConfirm: Pickup;
  /**
   * Create a new `Pickup` for a `Customer` in an owned `Reservation`.
   * This fails if the `Reservation` is not active or already being used for another `Pickup`.
   */
  pickupCreate: Pickup;
  /**
   * Delete a `Pickup` from the system, this does not free the `Reservation`.
   * You cannot delete a `Pickup` with `OrderItem`s associated with it, or a `Pickup`
   * that is either `COLLECTED` or `COLLECTING`.
   */
  pickupDelete: DeleteResult;
  /**
   * Extend the expiration of an expired `Pickup`, reactivating it to `CONFIRMED`.
   * This only works on `Pickup`s in the `EXPIRED` state and the new `expires_at`
   * must be in the future.
   */
  pickupExtend: Pickup;
  /**
   * Links a `OrderItem` to a `Pickup` and Creates a `UnlockRequest` for the filling of OrderItem
   *
   * # Errors
   * - If the `Pickup` is not in a fillable state (Blocked, Collecting, Confirmed)
   * - If the `Pickup` is for a different hub than the `OrderItem`'s `Order`
   * - If the `Hub` is currently offline
   * - If the `OrderItem` is already linked to another or the same `Pickup`, which means it has already been
   * filled before
   *
   * # Returns
   * The `unlock_request_id` of the created/attempted `UnlockRequest`
   *
   * # Pickup Status Transitions
   * - Pending -> Pending
   * - Confirmed -> Pending (When filling again the Pickup will require another confirmation)
   */
  pickupFill: Scalars['UUID']['output'];
  /**
   * Opens the `Space` associated with the `Pickup`.
   * Fails if the `Pickup` has already been collected or the `Reservation` is not active.
   * This is useful to correct any filling mistakes by taking out items, then unlinking them
   * via `orderItemRemove`.
   */
  pickupUnlock: Scalars['UUID']['output'];
  productCreate: Product;
  /**
   * Deletes a Product.
   * If the `Product` has a linked `ProductInstance` in any `HubProduct` this will instead deactivate.
   * If there are `ProductInstance` currently in any `Hub` the operation will fail.
   */
  productDelete: ProductDeleteResult;
  /**
   * Creates a new ProductInstance and unlocks the `Reservation` compartment
   * HubProduct and Reservation need to be owned by the User's Organization
   */
  productFill: ProductInstance;
  productInstanceDelete: DeleteResult;
  /** Retrieves a ProductInstance from the Hub */
  productInstanceRetrieve: UnlockRequest;
  productUpdate: Product;
  /**
   * Take another attempt on a raffle. The state of the `Raffle` can be queried by resolving
   * `raffle`. This will always show if the raffle is `ONGOING`, `WINNER` or `LOSER`.
   */
  raffleAttemptCreate: RaffleAttempt;
  /** Create a new raffle */
  raffleEnter: Raffle;
  /** Fetch the consolation price for a `LOSER` raffle */
  raffleFetchConsolation: UnlockRequest;
  /**
   * Triggers the asynchronous creation of a reservation for the given `space_id`.
   * Returns the `id` of the `Reservation` that will be created
   */
  raffleReservationCreate: Scalars['UUID']['output'];
  /**
   * Deactivates a RaffleReservation.
   * The operation is rejected if the usecase is either `PRIZE` or `CONSOLATION`.
   * Transition to `EMPTY` first by clearing the compartment, then you can deactivate the reservation.
   * The deactivation is asynchronous, fetch the model again to see if it has completed
   */
  raffleReservationDeactivate: Scalars['UUID']['output'];
  /**
   * Updates a RaffleReservation and unlocks the compartment at the same time.
   * This makes it easy to swap between prizes and usecases and directly change
   * the contents of the compartment.
   */
  raffleReservationUpdateUnlock: RaffleReservation;
  /** Admin only: delete a raffle */
  raffleTerminate: Scalars['UUID']['output'];
  /** Resend the pickup email to the customer if they did not receive it yet */
  resendPickupEmail: Pickup;
  /**
   * Sets or clears the note on a reservation.
   * B2C reservations: only baceadmin can call this.
   * B2B reservations: baceadmin or subjects in the owning organization.
   */
  reservationNoteSet: Reservation;
  serviceProviderAdd: HubMeta;
  serviceProviderRemove: HubMeta;
  sncOrderCreate: SncOrder;
  sncOrderDelete: DeleteResult;
  sncProductCreate: SncProduct;
  sncProductUpdate: SncProduct;
  spaceCreate: Space;
  spaceOpenUnsafe: Space;
  spaceUpdate: Space;
  subscriptionCreate: SubscriptionCreateCheckoutSession;
  /**
   * Creates a unlock request for a reservation's space.
   * This operation is idempotent, existing pending requests will not be duplicated.
   * This can be called either by a BACEADMIN or by the reservation's organization.
   */
  unlockRequestCreate: UnlockRequest;
  updateOrganizationMemberRole: OrganizationMember;
  updateUserPreferences: User;
  /**
   * End a B2B rental using an anonymous invite access token.
   * No authentication required: the secret token grants access.
   */
  utilizationGrantEndRentalAnonymous: Scalars['UUID']['output'];
  utilizationGrantUse: GrantUnlock;
  /**
   * Use an anonymous invite access token to unlock a reservation.
   * No authentication required: the secret token grants access.
   */
  utilizationGrantUseAnonymous: GrantUnlock;
  vendingImageCreate: ImageUpload;
  /**
   * Triggers the asynchronous creation of a reservation for the given `space_id`.
   * Returns the `id` of the `Reservation` that will be created
   */
  vendingReservationCreate: Scalars['UUID']['output'];
  vendingReservationDeactivate: VendingReservation;
  warehouseCreate: Warehouse;
  warehouseHubLink: Warehouse;
  warehouseHubUnlink: Warehouse;
  warehouseUpdate: Warehouse;
};


export type MutationB2BLockReservationCreateArgs = {
  input: LockReservationCreateInput;
};


export type MutationB2BLockReservationDeactivateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationB2CLockSessionCreateArgs = {
  input: B2CcheckoutCreateInput;
};


export type MutationB2CLockSessionEndArgs = {
  input: B2ClockSessionEndInput;
};


export type MutationB2CLockSessionPaymentContinueArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationB2bNotificationRecipientDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationB2bNotificationRecipientSaveArgs = {
  input: B2BNotificationRecipientInput;
};


export type MutationBrandCreateArgs = {
  input: BrandCreateInput;
};


export type MutationBrandDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationBrandUpdateArgs = {
  input: BrandUpdateInput;
};


export type MutationBundleCancelArgs = {
  input: BundleCancelInput;
};


export type MutationBundleCollectArgs = {
  input: BundleCollectInput;
};


export type MutationBundleCompartmentReturnToWarehouseArgs = {
  input: BundleCompartmentReturnInput;
  notificationUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBundleConfirmArgs = {
  input: BundleInput;
  notificationUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBundleCreateArgs = {
  input: BundleCreateInput;
};


export type MutationBundleDestinationSetArgs = {
  input: BundleDestinationSetInput;
};


export type MutationBundleDispatchToHubArgs = {
  input: BundleInput;
};


export type MutationBundlePackagesReturnToWarehouseArgs = {
  input: BundlePackagesReturnInput;
};


export type MutationBundleReadyForPickupArgs = {
  input: BundleInput;
};


export type MutationCapacityCreateArgs = {
  input: CapacityCreateInput;
};


export type MutationCapacityDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCapacityUpdateArgs = {
  input: CapacityUpdateInput;
};


export type MutationCategoryCreateArgs = {
  input: CategoryCreateInput;
};


export type MutationCategoryDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCategoryUpdateArgs = {
  input: CategoryUpdateInput;
};


export type MutationClickNCollectReservationCreateArgs = {
  input: ClickNCollectReservationCreateInput;
};


export type MutationClickNCollectReservationDeactivateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCncHubSettingsCreateArgs = {
  input: HubSettingsCreateInput;
};


export type MutationCncHubSettingsUpdateArgs = {
  input: HubSettingsUpdateInput;
};


export type MutationCoreReservationCreateArgs = {
  input: ReservationCreateInput;
};


export type MutationCoreReservationDeactivateArgs = {
  input: ReservationDeactivateInput;
};


export type MutationCreditGrantArgs = {
  input: CreditGrantInput;
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationHubCreateArgs = {
  input: HubCreateInput;
};


export type MutationHubMetaCreateArgs = {
  input: HubMetaCreateInput;
};


export type MutationHubMetaUpdateArgs = {
  input: HubMetaUpdateInput;
};


export type MutationHubProductCreateArgs = {
  input: HubProductCreateInput;
};


export type MutationHubProductDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationHubProductReactivateArgs = {
  input: HubProductReactivateInput;
};


export type MutationHubProductUpdateArgs = {
  input: HubProductUpdateInput;
};


export type MutationInstantBuyClaimArgs = {
  by: InstantBuyBy;
};


export type MutationInstantBuyCreateArgs = {
  input: InstantBuyCreateInput;
};


export type MutationInstantBuyDeleteArgs = {
  instantBuyBy: InstantBuyBy;
};


export type MutationLineItemRetrieveArgs = {
  input: LineItemRetrieveInput;
};


export type MutationLockReservationUnlockArgs = {
  input: LockReservationUnlockInput;
};


export type MutationLockUtilizationGrantCreateArgs = {
  input: UtilizationGrantCreateInput;
};


export type MutationLockUtilizationGrantDeactivateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationLockUtilizationGrantInviteAnonymousArgs = {
  input: UtilizationGrantInviteAnonymousInput;
};


export type MutationLockUtilizationGrantUpdateArgs = {
  input: UtilizationGrantUpdateInput;
};


export type MutationOnedeliveryReservationCreateArgs = {
  input: OnedeliveryReservationCreateInput;
};


export type MutationOpeningHoursCreateArgs = {
  input: OpeningHoursCreateInput;
};


export type MutationOpeningHoursDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationOpeningHoursUpdateArgs = {
  input: OpeningHoursUpdateInput;
};


export type MutationOrderCreateArgs = {
  input: OrderCreateInput;
};


export type MutationOrderDeleteArgs = {
  input: OrderDeleteInput;
};


export type MutationOrderItemCreateArgs = {
  input: OrderItemCreateInput;
};


export type MutationOrderItemDeleteArgs = {
  input: OrderItemDeleteInput;
};


export type MutationOrderItemRemoveArgs = {
  input: OrderItemRemoveInput;
};


export type MutationOrganizationScopesSetArgs = {
  input: OrganizationScopesSetInput;
};


export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};


export type MutationPackageCreateArgs = {
  input: PackageCreateInput;
  notificationUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPackageFillArgs = {
  input: PackageFillInput;
};


export type MutationPackageReturnsReceiveArgs = {
  input: PackageReturnsReceiveInput;
};


export type MutationPackageUserUnlinkArgs = {
  input: PackageUserUnlinkInput;
};


export type MutationPharmacyHubCreateArgs = {
  input: PharmacyHubCreateInput;
};


export type MutationPharmacyHubDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationPharmacyHubUpdateArgs = {
  input: PharmacyHubUpdateInput;
};


export type MutationPickupCollectArgs = {
  input: PickupCollectInput;
};


export type MutationPickupConfirmArgs = {
  input: PickupConfirmInput;
};


export type MutationPickupCreateArgs = {
  input: PickupCreateInput;
};


export type MutationPickupDeleteArgs = {
  input: PickupDeleteInput;
};


export type MutationPickupExtendArgs = {
  input: PickupExtendInput;
};


export type MutationPickupFillArgs = {
  input: PickupFillInput;
};


export type MutationPickupUnlockArgs = {
  input: PickupUnlockInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationProductFillArgs = {
  input: ProductFillInput;
};


export type MutationProductInstanceDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationProductInstanceRetrieveArgs = {
  input: ProductInstanceRetrieveInput;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type MutationRaffleAttemptCreateArgs = {
  input: RaffleAttemptCreateInput;
};


export type MutationRaffleEnterArgs = {
  input: RaffleCreateInput;
};


export type MutationRaffleFetchConsolationArgs = {
  input: RaffleConsolationFetchInput;
};


export type MutationRaffleReservationCreateArgs = {
  input: RaffleReservationCreateInput;
};


export type MutationRaffleReservationDeactivateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRaffleReservationUpdateUnlockArgs = {
  input: RaffleReservationUpdateInput;
};


export type MutationRaffleTerminateArgs = {
  input: RaffleTerminateInput;
};


export type MutationResendPickupEmailArgs = {
  pickupId: Scalars['UUID']['input'];
};


export type MutationReservationNoteSetArgs = {
  input: ReservationNoteSetInput;
};


export type MutationServiceProviderAddArgs = {
  input: ServiceProviderAddInput;
};


export type MutationServiceProviderRemoveArgs = {
  input: ServiceProviderRemoveInput;
};


export type MutationSncOrderCreateArgs = {
  input: SncOrderCreateInput;
};


export type MutationSncOrderDeleteArgs = {
  by: SncOrderBy;
};


export type MutationSncProductCreateArgs = {
  input: SncProductCreateInput;
};


export type MutationSncProductUpdateArgs = {
  input: SncProductUpdateInput;
};


export type MutationSpaceCreateArgs = {
  input: SpaceCreateInput;
};


export type MutationSpaceOpenUnsafeArgs = {
  spaceBy: SpaceBy;
};


export type MutationSpaceUpdateArgs = {
  input: SpaceUpdateInput;
};


export type MutationSubscriptionCreateArgs = {
  input: SubscriptionCreateInput;
};


export type MutationUnlockRequestCreateArgs = {
  input: UnlockRequestCreateInput;
};


export type MutationUpdateOrganizationMemberRoleArgs = {
  input: UpdateOrganizationMemberRoleInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};


export type MutationUtilizationGrantEndRentalAnonymousArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationUtilizationGrantUseArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUtilizationGrantUseAnonymousArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationVendingReservationCreateArgs = {
  input: VendingReservationCreateInput;
};


export type MutationVendingReservationDeactivateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationWarehouseCreateArgs = {
  input: WarehouseCreateInput;
};


export type MutationWarehouseHubLinkArgs = {
  input: WarehouseHubInput;
};


export type MutationWarehouseHubUnlinkArgs = {
  input: WarehouseHubInput;
};


export type MutationWarehouseUpdateArgs = {
  input: WarehouseUpdateInput;
};

export type MyUtilizationGrantsInput = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OnedeliveryReservation = Reservation & {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  packageCount: Scalars['Int']['output'];
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
};


export type OnedeliveryReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};

export type OnedeliveryReservationCreateInput = {
  /** Pregenerated by the client so asynchronous booking is idempotent. */
  reservationId: Scalars['UUID']['input'];
  spaceId: Scalars['UUID']['input'];
};

export type OpeningHours = {
  closesAt: Scalars['NaiveTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: Weekday;
  id: Scalars['UUID']['output'];
  opensAt: Scalars['NaiveTime']['output'];
  pharmacyHubId: Scalars['UUID']['output'];
};

export type OpeningHoursCreateInput = {
  closesAt: Scalars['NaiveTime']['input'];
  dayOfWeek: Weekday;
  opensAt: Scalars['NaiveTime']['input'];
  pharmacyHubId: Scalars['UUID']['input'];
};

export type OpeningHoursFilter = {
  dayOfWeek?: InputMaybe<Weekday>;
  pharmacyHubId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OpeningHoursOrderByEntry = {
  field: OpeningHoursOrderByField;
  ordering: Ordering;
};

export enum OpeningHoursOrderByField {
  CreatedAt = 'CREATED_AT',
  DayOfWeek = 'DAY_OF_WEEK',
  Id = 'ID',
  OpensAt = 'OPENS_AT'
}

export type OpeningHoursPage = {
  nodes: Array<OpeningHours>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OpeningHoursUpdateInput = {
  closesAt?: InputMaybe<Scalars['NaiveTime']['input']>;
  dayOfWeek?: InputMaybe<Weekday>;
  id: Scalars['UUID']['input'];
  opensAt?: InputMaybe<Scalars['NaiveTime']['input']>;
};

export type Order = {
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  externalId: Scalars['String']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  items: Array<OrderItem>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  sncOrder?: Maybe<SncOrder>;
  source: IntegrationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderBy = {
  /** Finds order by `ExternalId` and user organization. Requires a logged in user */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrderCreateCustomer = {
  /** Input to create a new Customer */
  customer?: InputMaybe<CustomerCreateInput>;
  /** Customer ID in the CnC system */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrderCreateInput = {
  customer: OrderCreateCustomer;
  externalId: Scalars['String']['input'];
  hubId: Scalars['UUID']['input'];
  items?: Array<OrderItemCreateInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type OrderDeleteInput = {
  orderId: Scalars['UUID']['input'];
};

export type OrderFilter = {
  hubIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  source?: InputMaybe<Array<IntegrationType>>;
};

export type OrderItem = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  filledAt?: Maybe<Scalars['DateTime']['output']>;
  filledWith?: Maybe<UnlockRequest>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  order: Order;
  organization: Organization;
  pickup?: Maybe<Pickup>;
  sncLineItem?: Maybe<SncLineItem>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['UUID']['input'];
};

export type OrderItemDeleteInput = {
  orderItemId: Scalars['UUID']['input'];
};

export type OrderItemFilter = {
  filled?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  pickupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrderItemOrderByEntry = {
  field: OrderItemOrderByField;
  ordering: Ordering;
};

export enum OrderItemOrderByField {
  Id = 'ID',
  OrderId = 'ORDER_ID',
  OrganizationId = 'ORGANIZATION_ID'
}

export type OrderItemPage = {
  nodes: Array<OrderItem>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OrderItemRemoveInput = {
  orderItemId: Scalars['UUID']['input'];
};

export type OrderOrderByEntry = {
  field: OrderOrderByField;
  ordering: Ordering;
};

export enum OrderOrderByField {
  Id = 'ID',
  Source = 'SOURCE'
}

export type OrderPage = {
  nodes: Array<Order>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrgGrantInput = {
  organizationId: Scalars['UUID']['input'];
};

export type OrgUserInput = {
  organizationId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type Organization = {
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hubs: Array<HubMeta>;
  id: Scalars['UUID']['output'];
  imprint?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<CloudflareImage>;
  members: OrganizationMemberPage;
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pharmacyHubs: PharmacyHubPage;
  phone?: Maybe<Scalars['String']['output']>;
  publicOrganizationName?: Maybe<Scalars['String']['output']>;
  publicShowcaseImageId?: Maybe<CloudflareImage>;
  scopes: Array<OrganizationScope>;
  slug: Scalars['String']['output'];
  supportEmail?: Maybe<Scalars['String']['output']>;
  warehouses: WarehousePage;
};


export type OrganizationMembersArgs = {
  filter?: InputMaybe<OrganizationMemberFilter>;
  orderBy?: Array<OrganizationMemberOrderByEntry>;
  pagination?: PaginationInput;
};


export type OrganizationPharmacyHubsArgs = {
  filter?: InputMaybe<PharmacyHubFilter>;
  orderBy?: Array<PharmacyHubOrderByEntry>;
  pagination?: PaginationInput;
};


export type OrganizationWarehousesArgs = {
  filter?: InputMaybe<WarehouseFilter>;
  orderBy?: Array<WarehouseOrderByEntry>;
  pagination?: PaginationInput;
};

export type OrganizationFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<OrganizationScope>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMember = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  role: OrganizationRole;
  user: User;
  userId: Scalars['UUID']['output'];
};

export type OrganizationMemberBy = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  orgUser?: InputMaybe<OrgUserInput>;
};

export type OrganizationMemberFilter = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<OrganizationRole>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMemberOrderByEntry = {
  field: OrganizationMemberOrderByField;
  ordering: Ordering;
};

export enum OrganizationMemberOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Role = 'ROLE'
}

export type OrganizationMemberPage = {
  nodes: Array<OrganizationMember>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OrganizationOrderByEntry = {
  field: OrganizationOrderByField;
  ordering: Ordering;
};

export enum OrganizationOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

export type OrganizationPage = {
  nodes: Array<Organization>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum OrganizationScope {
  ClickNCollect = 'CLICK_N_COLLECT',
  LockB2B = 'LOCK_B2B',
  LockB2C = 'LOCK_B2C',
  ManualOrder = 'MANUAL_ORDER',
  Onedelivery = 'ONEDELIVERY',
  Pharmacy = 'PHARMACY',
  Raffle = 'RAFFLE',
  ShopNCollect = 'SHOP_N_COLLECT',
  /** Organization with Tier 1 contract */
  T1 = 'T1',
  /** Organization with Tier 2 contract */
  T2 = 'T2',
  Vending = 'VENDING'
}

export type OrganizationScopesSetInput = {
  organizationId: Scalars['UUID']['input'];
  scopes: Array<OrganizationScope>;
};

export type OrganizationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imprint?: InputMaybe<Scalars['String']['input']>;
  logoImageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicOrganizationName?: InputMaybe<Scalars['String']['input']>;
  publicShowcaseImageId?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OutputDimensions = {
  depthMm: Scalars['Int']['output'];
  heightMm: Scalars['Int']['output'];
  widthMm: Scalars['Int']['output'];
};

export type Package = {
  bundle?: Maybe<Bundle>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  creditId?: Maybe<Scalars['UUID']['output']>;
  events: PackageEventPage;
  id: Scalars['String']['output'];
  reservation?: Maybe<OnedeliveryReservation>;
  status: PackageStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  version: Scalars['Int']['output'];
  warehouse: Warehouse;
};


export type PackageEventsArgs = {
  pagination?: PaginationInput;
};

export type PackageCreateInput = {
  /** Unique package label; creation with an existing ID is rejected. */
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  warehouseId: Scalars['UUID']['input'];
};

export type PackageEvent = {
  actor: User;
  data: Scalars['JSON']['output'];
  packageId: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
  schemaVersion: Scalars['Int']['output'];
  sequence: Scalars['Int']['output'];
};

export type PackageEventPage = {
  nodes: Array<PackageEvent>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PackageFillInput = {
  /** Packages to place together in one compartment. They must share a Bundle. */
  packageIds: Array<Scalars['String']['input']>;
  reservationId: Scalars['UUID']['input'];
};

export type PackageFillResult = {
  bundle: Bundle;
  packages: Array<Package>;
  reservation: OnedeliveryReservation;
  unlockRequestId: Scalars['UUID']['output'];
};

export type PackagePage = {
  nodes: Array<Package>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PackageReturnsReceiveInput = {
  packageIds: Array<Scalars['String']['input']>;
};

export enum PackageStatus {
  Collected = 'COLLECTED',
  InCompartment = 'IN_COMPARTMENT',
  InTransitToHub = 'IN_TRANSIT_TO_HUB',
  InTransitToWarehouse = 'IN_TRANSIT_TO_WAREHOUSE',
  InWarehouse = 'IN_WAREHOUSE'
}

export type PackageUserUnlinkInput = {
  packageId: Scalars['String']['input'];
};

/** Information about pagination in a connection */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type PharmacyHub = {
  consultationInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hubId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  openingHours: OpeningHoursPage;
  openingHoursUrl?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  phone: Scalars['String']['output'];
};


export type PharmacyHubOpeningHoursArgs = {
  filter?: InputMaybe<OpeningHoursFilter>;
  orderBy?: Array<OpeningHoursOrderByEntry>;
  pagination?: PaginationInput;
};

export type PharmacyHubCreateInput = {
  consultationInfo?: InputMaybe<Scalars['String']['input']>;
  hubId: Scalars['UUID']['input'];
  openingHoursUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  phone: Scalars['String']['input'];
};

export type PharmacyHubFilter = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PharmacyHubOrderByEntry = {
  field: PharmacyHubOrderByField;
  ordering: Ordering;
};

export enum PharmacyHubOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type PharmacyHubPage = {
  nodes: Array<PharmacyHub>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PharmacyHubUpdateInput = {
  consultationInfo?: InputMaybe<Scalars['String']['input']>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  openingHoursUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Pickup = {
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hub: Hub;
  id: Scalars['UUID']['output'];
  orderItems: Array<OrderItem>;
  organization: Organization;
  remindedAt?: Maybe<Scalars['DateTime']['output']>;
  reservation: ClickNCollectReservation;
  reservationId: Scalars['UUID']['output'];
  status: PickupStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PickupCollectInput = {
  pickupId: Scalars['UUID']['input'];
};

export type PickupConfirmInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  pickupId: Scalars['UUID']['input'];
};

export type PickupCreateInput = {
  customerId: Scalars['UUID']['input'];
  reservationId: Scalars['UUID']['input'];
};

export type PickupDeleteInput = {
  pickupId: Scalars['UUID']['input'];
};

export type PickupExtendInput = {
  expiresAt: Scalars['DateTime']['input'];
  pickupId: Scalars['UUID']['input'];
};

export type PickupFillInput = {
  /** @deprecated Use `order_item_ids` instead */
  orderItemId?: InputMaybe<Scalars['UUID']['input']>;
  orderItemIds?: Array<Scalars['UUID']['input']>;
  pickupId: Scalars['UUID']['input'];
};

export type PickupFilter = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  hubIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Array<PickupStatus>>;
};

export type PickupOrderByEntry = {
  field: PickupOrderByField;
  ordering: Ordering;
};

export enum PickupOrderByField {
  Id = 'ID',
  OrganizationId = 'ORGANIZATION_ID',
  Status = 'STATUS'
}

export type PickupPage = {
  nodes: Array<Pickup>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum PickupStatus {
  Blocked = 'BLOCKED',
  Collected = 'COLLECTED',
  Collecting = 'COLLECTING',
  Confirmed = 'CONFIRMED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type PickupUnlockInput = {
  pickupId: Scalars['UUID']['input'];
};

export type Product = {
  active: Scalars['Boolean']['output'];
  brand: Brand;
  brandId: Scalars['UUID']['output'];
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultPrice: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hubProducts: HubProductPage;
  id: Scalars['UUID']['output'];
  imageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  photo: CloudflareImage;
  stripeProductId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vat: Scalars['Int']['output'];
};


export type ProductHubProductsArgs = {
  orderBy?: Array<HubProductOrderByEntry>;
  pagination?: PaginationInput;
};

export type ProductCreateInput = {
  brandId: Scalars['UUID']['input'];
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  defaultPriceAmount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  vat: Scalars['Int']['input'];
};

/**
 * The result of a delete operation on a `Product`
 * - Successfully deleted
 * - Deactivated the Product instead
 * - Non trivial error encountered while attempting to delete
 */
export type ProductDeleteResult = DeleteResultFailure | DeleteResultSuccess | Product;

export type ProductFillInput = {
  hubProductId: Scalars['UUID']['input'];
  reservationId: Scalars['UUID']['input'];
};

export type ProductFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<BrandFilter>;
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  category?: InputMaybe<CategoryFilter>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductInstance = {
  createdAt: Scalars['DateTime']['output'];
  filledWith: UnlockRequest;
  filledWithId: Scalars['UUID']['output'];
  hubProduct: HubProduct;
  id: Scalars['UUID']['output'];
  lineItem?: Maybe<LineItem>;
  organization: Organization;
  reservation: VendingReservation;
  retrievedWith?: Maybe<UnlockRequest>;
  retrievedWithId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductInstanceFilter = {
  hubProduct?: InputMaybe<HubProductFilter>;
  hubProductId?: InputMaybe<Scalars['UUID']['input']>;
  inHub?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  reservationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductInstanceOrderByEntry = {
  field: ProductInstanceOrderByField;
  ordering: Ordering;
};

export enum ProductInstanceOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  RetrievedWithId = 'RETRIEVED_WITH_ID',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductInstancePage = {
  nodes: Array<ProductInstance>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProductInstanceRetrieveInput = {
  /** ProductInstance ID */
  id: Scalars['UUID']['input'];
};

export type ProductOrderByEntry = {
  field: ProductOrderByField;
  ordering: Ordering;
};

export enum ProductOrderByField {
  Active = 'ACTIVE',
  CreatedAt = 'CREATED_AT',
  DefaultPrice = 'DEFAULT_PRICE',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  Vat = 'VAT'
}

export type ProductPage = {
  nodes: Array<Product>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProductUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceAmount?: InputMaybe<Scalars['Int']['input']>;
  vat?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  anonymousUtilizationGrant: UtilizationGrant;
  b2CLockSession?: Maybe<B2ClockSession>;
  b2CLockSessionFeeEstimate: Scalars['JSONObject']['output'];
  b2bNotificationRecipients: B2BNotificationRecipientPage;
  brand?: Maybe<Brand>;
  brands: BrandPage;
  bundle: Bundle;
  bundles: BundlePage;
  capacities: CapacityPage;
  capacitiesConnection: CapacityConnection;
  capacity?: Maybe<Capacity>;
  categories: CategoryPage;
  category?: Maybe<Category>;
  cncHubSettings?: Maybe<CnCHubSettings>;
  cncHubSettingsList: CnCHubSettingsPage;
  creditBalance: CreditBalance;
  credits: CreditPage;
  customer?: Maybe<Customer>;
  customers: CustomerPage;
  hub?: Maybe<Hub>;
  hubMeta?: Maybe<HubMeta>;
  hubMetas: HubMetaPage;
  hubMetasConnection: HubMetaConnection;
  hubProduct?: Maybe<HubProduct>;
  hubProducts: HubProductPage;
  hubs: HubPage;
  hubsConnection: HubConnection;
  instantBuy?: Maybe<InstantBuy>;
  instantBuys: InstantBuyPage;
  invitation?: Maybe<Invitation>;
  invitations: InvitationPage;
  lockReservations: LockReservationPage;
  /**
   * All active Lock grants for the current user. Both B2B and B2C grants are returned.
   * Can filter optionally by `hub_id` on input type
   */
  myUtilizationGrants: UtilizationGrantPage;
  /** Public smoke test for the One Delivery 2.0 subgraph; returns no user data. */
  onedelivery: Scalars['String']['output'];
  onedeliveryReservation: OnedeliveryReservation;
  openingHour?: Maybe<OpeningHours>;
  openingHours: OpeningHoursPage;
  order?: Maybe<Order>;
  orderBy?: Maybe<Order>;
  orderItemFind?: Maybe<OrderItem>;
  orderItems: OrderItemPage;
  orders: OrderPage;
  organization?: Maybe<Organization>;
  organizationMember?: Maybe<OrganizationMember>;
  organizationMembers: OrganizationMemberPage;
  organizationPackages: PackagePage;
  organizations: OrganizationPage;
  package: Package;
  packages: PackagePage;
  pharmacyHub?: Maybe<PharmacyHub>;
  pharmacyHubs: PharmacyHubPage;
  pickup?: Maybe<Pickup>;
  pickups: PickupPage;
  product?: Maybe<Product>;
  productInstance?: Maybe<ProductInstance>;
  productInstances: ProductInstancePage;
  products: ProductPage;
  /** Get a single raffle by ID */
  raffle?: Maybe<Raffle>;
  /** Get a single raffle attempt by ID */
  raffleAttempt?: Maybe<RaffleAttempt>;
  /** Get paginated list of raffle attempts */
  raffleAttempts: RaffleAttemptPage;
  /** Get paginated list of raffles */
  raffles: RafflePage;
  /** Get a reservation by ID. */
  reservation?: Maybe<Reservation>;
  /** Generic reservations query API */
  reservations: ReservationPage;
  /** Generic reservations connection query API */
  reservationsConnection: ReservationConnection;
  sncLineItem?: Maybe<SncLineItem>;
  sncLineItems: SncLineItemPage;
  sncOrder?: Maybe<SncOrder>;
  sncOrders: SncOrderPage;
  sncProduct?: Maybe<SncProduct>;
  sncProducts: SncProductPage;
  space?: Maybe<Space>;
  spaces: SpacePage;
  spacesConnection: SpaceConnection;
  subscription?: Maybe<Subscription>;
  subscriptions: SubscriptionPage;
  unlockRequest?: Maybe<UnlockRequest>;
  unlockRequests: UnlockRequestPage;
  unlockRequestsConnection: UnlockRequestConnection;
  user?: Maybe<User>;
  users: UserPage;
  vendingExport: VendingExport;
};


export type QueryAnonymousUtilizationGrantArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryB2CLockSessionArgs = {
  by: B2CsessionBy;
};


export type QueryB2CLockSessionFeeEstimateArgs = {
  input: B2ClockSessionFeeEstimateInput;
};


export type QueryB2bNotificationRecipientsArgs = {
  pagination?: PaginationInput;
};


export type QueryBrandArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBrandsArgs = {
  filter?: InputMaybe<BrandFilter>;
  orderBy?: Array<BrandOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryBundleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBundlesArgs = {
  filter?: BundleFilter;
  pagination?: PaginationInput;
};


export type QueryCapacitiesArgs = {
  filter?: InputMaybe<CapacityFilter>;
  orderBy?: Array<CapacityOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryCapacitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CapacityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCapacityArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<CategoryFilter>;
  orderBy?: Array<CategoryOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCncHubSettingsArgs = {
  hubId: Scalars['UUID']['input'];
};


export type QueryCncHubSettingsListArgs = {
  filter?: InputMaybe<HubSettingsFilter>;
  orderBy?: Array<HubSettingsOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryCreditBalanceArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCreditsArgs = {
  filter?: CreditFilter;
  pagination?: PaginationInput;
};


export type QueryCustomerArgs = {
  by: CustomerBy;
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  orderBy?: Array<CustomerOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryHubArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryHubMetaArgs = {
  by: HubMetaBy;
};


export type QueryHubMetasArgs = {
  filter?: InputMaybe<HubMetaFilter>;
  orderBy?: Array<HubMetaOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryHubMetasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HubMetaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHubProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryHubProductsArgs = {
  filter?: InputMaybe<HubProductFilter>;
  orderBy?: Array<HubProductOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryHubsArgs = {
  filter?: InputMaybe<HubFilter>;
  orderBy?: Array<HubOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryHubsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HubFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInstantBuyArgs = {
  by: InstantBuyBy;
};


export type QueryInstantBuysArgs = {
  filter?: InputMaybe<InstantBuyFilter>;
  orderBy?: Array<InstantBuyOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryInvitationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryInvitationsArgs = {
  filter?: InputMaybe<InvitationFilter>;
  orderBy?: Array<InvitationOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryLockReservationsArgs = {
  filter: LockReservationFilter;
  orderBy?: Array<LockReservationOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryMyUtilizationGrantsArgs = {
  input?: MyUtilizationGrantsInput;
  orderBy?: Array<UtilizationGrantOrderByEntry>;
  pagination: PaginationInput;
};


export type QueryOnedeliveryReservationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOpeningHourArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOpeningHoursArgs = {
  filter?: InputMaybe<OpeningHoursFilter>;
  orderBy?: Array<OpeningHoursOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrderByArgs = {
  by: OrderBy;
};


export type QueryOrderItemFindArgs = {
  externalId: Scalars['String']['input'];
};


export type QueryOrderItemsArgs = {
  filter?: InputMaybe<OrderItemFilter>;
  orderBy?: Array<OrderItemOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  orderBy?: Array<OrderOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganizationMemberArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganizationMembersArgs = {
  filter?: InputMaybe<OrganizationMemberFilter>;
  orderBy?: Array<OrganizationMemberOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryOrganizationPackagesArgs = {
  organizationId: Scalars['UUID']['input'];
  pagination?: PaginationInput;
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  orderBy?: Array<OrganizationOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryPackageArgs = {
  id: Scalars['String']['input'];
};


export type QueryPackagesArgs = {
  pagination?: PaginationInput;
  warehouseId: Scalars['UUID']['input'];
};


export type QueryPharmacyHubArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPharmacyHubsArgs = {
  filter?: InputMaybe<PharmacyHubFilter>;
  orderBy?: Array<PharmacyHubOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryPickupArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPickupsArgs = {
  filter?: InputMaybe<PickupFilter>;
  orderBy?: Array<PickupOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductInstancesArgs = {
  filter?: InputMaybe<ProductInstanceFilter>;
  orderBy?: Array<ProductInstanceOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  orderBy?: Array<ProductOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryRaffleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRaffleAttemptArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRaffleAttemptsArgs = {
  filter?: InputMaybe<RaffleAttemptFilter>;
  orderBy?: Array<RaffleAttemptOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryRafflesArgs = {
  filter?: InputMaybe<RaffleFilter>;
  orderBy?: Array<RaffleOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryReservationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryReservationsArgs = {
  filter?: InputMaybe<ReservationFilter>;
  orderBy?: Array<ReservationOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryReservationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySncLineItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySncLineItemsArgs = {
  filter?: InputMaybe<SncLineItemFilter>;
  orderBy?: Array<SncLineItemOrderByEntry>;
  pagination?: PaginationInput;
};


export type QuerySncOrderArgs = {
  by: SncOrderBy;
};


export type QuerySncOrdersArgs = {
  filter?: InputMaybe<SncOrderFilter>;
  orderBy?: Array<SncOrderOrderByEntry>;
  pagination?: PaginationInput;
};


export type QuerySncProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySncProductsArgs = {
  filter?: InputMaybe<SncProductFilter>;
  orderBy?: Array<SncProductOrderByEntry>;
  pagination?: PaginationInput;
};


export type QuerySpaceArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySpacesArgs = {
  filter?: InputMaybe<SpaceFilter>;
  orderBy?: Array<SpaceOrderByEntry>;
  pagination?: PaginationInput;
};


export type QuerySpacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
  orderBy?: Array<SubscriptionOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryUnlockRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryUnlockRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UnlockRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  orderBy?: Array<UserOrderByEntry>;
  pagination?: PaginationInput;
};


export type QueryVendingExportArgs = {
  filter: VendingExportFilter;
};

export type Raffle = {
  consolationUnlockRequest?: Maybe<UnlockRequest>;
  createdAt: Scalars['DateTime']['output'];
  /** Get the hub associated with this raffle */
  hub: Hub;
  id: Scalars['UUID']['output'];
  /** Get all raffle attempts for this raffle */
  raffleAttempts: Array<RaffleAttempt>;
  status: RaffleStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** Get the user who owns this raffle */
  user: User;
};

export type RaffleAttempt = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Get the raffle this attempt belongs to */
  raffle: Raffle;
  /** Get the reservation associated with this attempt */
  reservation: RaffleReservation;
  /** Get the unlock request associated with this attempt */
  unlockRequest: UnlockRequest;
  updatedAt: Scalars['DateTime']['output'];
};

export type RaffleAttemptCreateInput = {
  raffleId: Scalars['UUID']['input'];
  reservationId: Scalars['UUID']['input'];
};

export type RaffleAttemptFilter = {
  raffleId?: InputMaybe<Scalars['UUID']['input']>;
  reservationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RaffleAttemptOrderByEntry = {
  field: RaffleAttemptOrderByField;
  ordering: Ordering;
};

export enum RaffleAttemptOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type RaffleAttemptPage = {
  nodes: Array<RaffleAttempt>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Get the consolation prize for a `LOSER` raffle */
export type RaffleConsolationFetchInput = {
  raffleId: Scalars['UUID']['input'];
};

export type RaffleCreateInput = {
  hubId: Scalars['UUID']['input'];
};

export type RaffleFilter = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RaffleOrderByEntry = {
  field: RaffleOrderByField;
  ordering: Ordering;
};

export enum RaffleOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type RafflePage = {
  nodes: Array<Raffle>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RaffleReservation = Reservation & {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
  usecase: RaffleUsecase;
};


export type RaffleReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};

export type RaffleReservationCreateInput = {
  spaceId: Scalars['UUID']['input'];
  usecase?: RaffleUsecase;
};

export type RaffleReservationUpdateInput = {
  reservationId: Scalars['UUID']['input'];
  usecase: RaffleUsecase;
};

export enum RaffleStatus {
  Loser = 'LOSER',
  Ongoing = 'ONGOING',
  Winner = 'WINNER'
}

export type RaffleTerminateInput = {
  raffleId: Scalars['UUID']['input'];
};

export enum RaffleUsecase {
  Consolation = 'CONSOLATION',
  Empty = 'EMPTY',
  Prize = 'PRIZE'
}

export type Reservation = {
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
};


export type ReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy: Array<UnlockRequestOrderByEntry>;
  pagination: PaginationInput;
};

export type ReservationConnection = {
  /** A list of edges. */
  edges: Array<ReservationEdge>;
  /** A list of nodes. */
  nodes: Array<Reservation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ReservationCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['UUID']['input'];
};

export type ReservationDeactivateInput = {
  reservationId: Scalars['UUID']['input'];
};

/** An edge in a connection. */
export type ReservationEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Reservation;
};

export type ReservationFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<TimestampFilter>;
  deactivatedAt?: InputMaybe<TimestampFilter>;
  flex?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  services?: InputMaybe<Array<Service>>;
  space?: InputMaybe<SpaceFilter>;
  spaceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReservationNoteSetInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['UUID']['input'];
};

export type ReservationOrderByEntry = {
  field: ReservationOrderByField;
  ordering: Ordering;
};

export enum ReservationOrderByField {
  CreatedAt = 'CREATED_AT',
  DeactivatedAt = 'DEACTIVATED_AT',
  Flex = 'FLEX',
  Id = 'ID',
  OrganizationId = 'ORGANIZATION_ID',
  UpdatedAt = 'UPDATED_AT'
}

export type ReservationPage = {
  nodes: Array<Reservation>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum Service {
  ClickNCollect = 'CLICK_N_COLLECT',
  /** Special service which represents this service itself */
  Core = 'CORE',
  Lock = 'LOCK',
  Onedelivery = 'ONEDELIVERY',
  Raffle = 'RAFFLE',
  Vending = 'VENDING'
}

export type ServiceProviderAddInput = {
  hubMetaId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type ServiceProviderRemoveInput = {
  hubMetaId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type SncLineItem = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  priceAmount: Scalars['Int']['output'];
  sncOrder: SncOrder;
  sncProduct: SncProduct;
  updatedAt: Scalars['DateTime']['output'];
};

export type SncLineItemFilter = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  sncOrderId?: InputMaybe<Scalars['UUID']['input']>;
  sncProduct?: InputMaybe<SncProductFilter>;
  sncProductId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SncLineItemOrderByEntry = {
  field: SncLineItemOrderByField;
  ordering: Ordering;
};

export enum SncLineItemOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type SncLineItemPage = {
  nodes: Array<SncLineItem>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SncOrder = {
  amount: Scalars['Int']['output'];
  clientReferenceId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  lineItems: SncLineItemPage;
  organization: Organization;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SncOrderStatus;
  stripeClientSecret: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};


export type SncOrderLineItemsArgs = {
  filter?: InputMaybe<SncLineItemFilter>;
  orderBy?: Array<SncLineItemOrderByEntry>;
  pagination?: PaginationInput;
};

export type SncOrderBy = {
  clientReferenceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type SncOrderCreateInput = {
  clientReferenceId: Scalars['String']['input'];
  hubId: Scalars['UUID']['input'];
  items: Array<SncOrderItemInput>;
  returnUrl: Scalars['String']['input'];
};

export type SncOrderFilter = {
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<SncOrderStatus>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SncOrderItemInput = {
  quantity: Scalars['Int']['input'];
  sncProductId: Scalars['UUID']['input'];
};

export type SncOrderOrderByEntry = {
  field: SncOrderOrderByField;
  ordering: Ordering;
};

export enum SncOrderOrderByField {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type SncOrderPage = {
  nodes: Array<SncOrder>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SncOrderStatus {
  /** The order session has been closed */
  Closed = 'CLOSED',
  /** The order has been filled/fulfilled by the ClickNCollect integration */
  Filled = 'FILLED',
  /** The SncOrder is currently open for checkout in stripe */
  Open = 'OPEN',
  /** The order has been captured by stripe, officially becoming a purchase */
  Purchased = 'PURCHASED'
}

export type SncProduct = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  organization: Organization;
  priceAmount: Scalars['Int']['output'];
  product: Product;
  stock: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SncProductCreateInput = {
  hubId: Scalars['UUID']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
  stock: Scalars['Int']['input'];
};

export type SncProductFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<ProductFilter>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SncProductOrderByEntry = {
  field: SncProductOrderByField;
  ordering: Ordering;
};

export enum SncProductOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type SncProductPage = {
  nodes: Array<SncProduct>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SncProductUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
};

export type Space = {
  activeReservation?: Maybe<Reservation>;
  category: SpaceCategory;
  configuration: SpaceConfiguration;
  deviceId: Scalars['String']['output'];
  dimensions: OutputDimensions;
  frame: Scalars['String']['output'];
  hub: Hub;
  id: Scalars['UUID']['output'];
  /** Last time the space was updated through MQTT */
  lastUpdate: Scalars['DateTime']['output'];
  lock: Scalars['Int']['output'];
  /**
   * The position of the space in its frame, (position, frame) is unique for each `hub_id`.
   * This value corresponds to the `lock` returned by *Hubby* in a `frame/hub` update.
   */
  position: Scalars['Int']['output'];
  reservations: ReservationPage;
  status: SpaceStatus;
};


export type SpaceReservationsArgs = {
  orderBy?: Array<ReservationOrderByEntry>;
  pagination?: PaginationInput;
};

export type SpaceBy = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<SpaceByPosition>;
};

export type SpaceByPosition = {
  frame: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};

export enum SpaceCategory {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS',
  Xxl = 'XXL'
}

export enum SpaceConfiguration {
  BaceClatteringStandard = 'BACE_CLATTERING_STANDARD',
  BaceSatelliteLargeExtended = 'BACE_SATELLITE_LARGE_EXTENDED',
  BaceSatelliteLargeStandard = 'BACE_SATELLITE_LARGE_STANDARD',
  BaceSatelliteMediumExtended = 'BACE_SATELLITE_MEDIUM_EXTENDED',
  BaceSatelliteMediumStandard = 'BACE_SATELLITE_MEDIUM_STANDARD',
  BaceSatelliteSmallExtended = 'BACE_SATELLITE_SMALL_EXTENDED',
  BaceSatelliteSmallSlim = 'BACE_SATELLITE_SMALL_SLIM',
  BaceSatelliteSmallStandard = 'BACE_SATELLITE_SMALL_STANDARD',
  BaceStorefront_2Xl = 'BACE_STOREFRONT_2XL',
  BaceStorefrontL = 'BACE_STOREFRONT_L',
  BaceStorefrontM = 'BACE_STOREFRONT_M',
  BaceStorefrontS = 'BACE_STOREFRONT_S',
  BaceStorefrontXl = 'BACE_STOREFRONT_XL',
  BaceTruckHubStandard = 'BACE_TRUCK_HUB_STANDARD',
  ThaliaRenzStandardM = 'THALIA_RENZ_STANDARD_M',
  ThaliaRenzStandardS = 'THALIA_RENZ_STANDARD_S',
  ThaliaRenzStandardXs = 'THALIA_RENZ_STANDARD_XS',
  ThaliaRenzWideM = 'THALIA_RENZ_WIDE_M',
  ThaliaRenzWideS = 'THALIA_RENZ_WIDE_S'
}

export type SpaceConnection = {
  /** A list of edges. */
  edges: Array<SpaceEdge>;
  /** A list of nodes. */
  nodes: Array<Space>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpaceCreateBase = {
  configuration: SpaceConfiguration;
  deviceId: Scalars['String']['input'];
  frame: Scalars['String']['input'];
  lock: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

export type SpaceCreateInput = {
  configuration: SpaceConfiguration;
  deviceId: Scalars['String']['input'];
  frame: Scalars['String']['input'];
  hubId: Scalars['UUID']['input'];
  lock: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

/** An edge in a connection. */
export type SpaceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Space;
};

export type SpaceFilter = {
  configuration?: InputMaybe<SpaceConfiguration>;
  frame?: InputMaybe<Scalars['String']['input']>;
  hub?: InputMaybe<HubFilter>;
  hubId?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type SpaceOrderByEntry = {
  field: SpaceOrderByField;
  ordering: Ordering;
};

export enum SpaceOrderByField {
  Configuration = 'CONFIGURATION',
  CreatedAt = 'CREATED_AT',
  Frame = 'FRAME',
  Id = 'ID',
  LastUpdate = 'LAST_UPDATE',
  Lock = 'LOCK',
  Position = 'POSITION',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type SpacePage = {
  nodes: Array<Space>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SpaceStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type SpaceUpdateInput = {
  configuration?: InputMaybe<SpaceConfiguration>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  frame?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  lock?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
};

export enum StripePaymentIntentStatus {
  Canceled = 'CANCELED',
  Processing = 'PROCESSING',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export enum StripeSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type Subscription = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  status: StripeSubscriptionStatus;
  stripeId: Scalars['String']['output'];
  tier: SubscriptionTier;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['UUID']['output'];
};

export type SubscriptionCreateCheckoutSession = {
  clientSecret: Scalars['String']['output'];
};

/** Subscribes the current logged user to `Onedelivery` with a subscription. */
export type SubscriptionCreateInput = {
  clientReferenceId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  tier?: SubscriptionTier;
};

export type SubscriptionFilter = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SubscriptionOrderByEntry = {
  field: SubscriptionOrderByField;
  ordering: Ordering;
};

export enum SubscriptionOrderByField {
  Id = 'ID'
}

export type SubscriptionPage = {
  nodes: Array<Subscription>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SubscriptionTier {
  Standard = 'STANDARD'
}

export type TimestampFilter = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
};

export type U16Filter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  ne?: InputMaybe<Scalars['UUID']['input']>;
};

export type UnlockRequest = {
  createdAt: Scalars['DateTime']['output'];
  /** Reason for error of the request. Implies `status == ERROR` */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  reservation: Reservation;
  reservationId: Scalars['UUID']['output'];
  status: UnlockRequestStatus;
  unlockedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type UnlockRequestConnection = {
  /** A list of edges. */
  edges: Array<UnlockRequestEdge>;
  /** A list of nodes. */
  nodes: Array<UnlockRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UnlockRequestCreateInput = {
  reservationId: Scalars['UUID']['input'];
  /** Pregenerated UUID for idempotency */
  unlockRequestId: Scalars['UUID']['input'];
};

/** An edge in a connection. */
export type UnlockRequestEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UnlockRequest;
};

export type UnlockRequestFilter = {
  reservation?: InputMaybe<ReservationFilter>;
  reservationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<UnlockRequestStatus>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UnlockRequestOrderByEntry = {
  field: UnlockRequestOrderByField;
  ordering: Ordering;
};

export enum UnlockRequestOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UnlockedAt = 'UNLOCKED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type UnlockRequestPage = {
  nodes: Array<UnlockRequest>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/**
 * Enum type to track the state progress of an unlock request
 * For a given `Space` only a single `UnlockRequest` in the following states can exist:
 * - `PENDING`
 * - `EXECUTED`
 *
 * These states point towards `Hubby` still working on processng the MQTT message, whilst the
 * others are terminal states.
 */
export enum UnlockRequestStatus {
  /** An error occurred and was returned by Hubby */
  Error = 'ERROR',
  /**
   * Request was acknowledged and executed by Hubby
   * This state is transitioned when `UnlockResponse::Ack` is received
   */
  Executed = 'EXECUTED',
  /**
   * Just created, default value. The request itself existing is proof our message reached the
   * MQTT broker.
   */
  Pending = 'PENDING',
  /**
   * Request timed out, either by Hubby timeout response or from core.
   * This state should be automatically transitioned to by the core
   * when we're sure the message has been discarded by the MQTT broker or
   * manually when a `UnlockResponse::Timeout` is received from Hubby.
   */
  TimedOut = 'TIMED_OUT',
  /** Space has been successfully unlocked */
  Unlocked = 'UNLOCKED'
}

export type UpdateOrganizationMemberRoleInput = {
  member: OrganizationMemberBy;
  role: OrganizationRole;
};

export type UpdateUserPreferencesInput = {
  preferences: Scalars['JSON']['input'];
};

export type User = {
  acceptedNewsletter?: Maybe<Scalars['Boolean']['output']>;
  acceptedPrivacyPolicyVersion?: Maybe<Scalars['Int']['output']>;
  acceptedTermsOfServiceVersion?: Maybe<Scalars['Int']['output']>;
  activeSncOrderCheckout?: Maybe<SncOrder>;
  banExpires?: Maybe<Scalars['DateTime']['output']>;
  banReason?: Maybe<Scalars['String']['output']>;
  banned?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  instantBuys: InstantBuyPage;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationMember?: Maybe<OrganizationMember>;
  /** Returns the `Raffle` for the user in the given hub */
  raffle?: Maybe<Raffle>;
  role: UserRole;
  sncOrders: SncOrderPage;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userPreferences?: Maybe<Scalars['JSON']['output']>;
};


export type UserInstantBuysArgs = {
  filter?: InputMaybe<InstantBuyFilter>;
  orderBy?: Array<InstantBuyOrderByEntry>;
  pagination?: PaginationInput;
};


export type UserRaffleArgs = {
  hubId: Scalars['UUID']['input'];
};


export type UserSncOrdersArgs = {
  filter?: InputMaybe<SncOrderFilter>;
  orderBy?: Array<SncOrderOrderByEntry>;
  pagination?: PaginationInput;
};

export type UserEmailGrantInput = {
  email: Scalars['String']['input'];
};

export type UserFilter = {
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
};

export type UserGrantInput = {
  userId: Scalars['UUID']['input'];
};

export type UserOrderByEntry = {
  field: UserOrderByField;
  ordering: Ordering;
};

export enum UserOrderByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  Id = 'ID',
  Name = 'NAME',
  Role = 'ROLE',
  UpdatedAt = 'UPDATED_AT'
}

export type UserPage = {
  nodes: Array<User>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum UserRole {
  BaceAdmin = 'BACE_ADMIN',
  User = 'USER'
}

export type UtilizationGrant = {
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Expiry of the grant, currently used for `Anonymous` invites. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * Permissions granted by this utilization grant, such as unlocking the lock
   * or ending the underlying rental.
   */
  permissions: Array<UtilizationGrantPermission>;
  reservation: LockReservation;
  /**
   * Email of the anonymous invitee. Set only for `Anonymous` grants,
   * where there is no bace user or organization to reference.
   */
  toEmail?: Maybe<Scalars['String']['output']>;
  toOrganization?: Maybe<Organization>;
  toUser?: Maybe<User>;
  ty: LockGrantType;
  updatedAt: Scalars['DateTime']['output'];
};

export type UtilizationGrantCreateInput = {
  permissions?: Array<UtilizationGrantPermission>;
  reservationId: Scalars['UUID']['input'];
  to: UtilizationGrantTo;
};

export type UtilizationGrantFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deactivatedAt?: InputMaybe<TimestampFilter>;
};

export type UtilizationGrantInviteAnonymousInput = {
  email: Scalars['String']['input'];
  /** Optional expiry for the invite link. When omitted the link does not expire. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissions?: Array<UtilizationGrantPermission>;
  reservationId: Scalars['UUID']['input'];
  returnBaseUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UtilizationGrantOrderByEntry = {
  field: UtilizationGrantOrderByField;
  ordering: Ordering;
};

export enum UtilizationGrantOrderByField {
  DeactivatedAt = 'DEACTIVATED_AT',
  Id = 'ID'
}

export type UtilizationGrantPage = {
  nodes: Array<UtilizationGrant>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum UtilizationGrantPermission {
  EndRental = 'END_RENTAL',
  Unlock = 'UNLOCK'
}

export type UtilizationGrantTo = {
  organization?: InputMaybe<OrgGrantInput>;
  user?: InputMaybe<UserGrantInput>;
  userEmail?: InputMaybe<UserEmailGrantInput>;
};

export type UtilizationGrantUpdateInput = {
  id: Scalars['UUID']['input'];
  permissions: Array<UtilizationGrantPermission>;
};

export enum Variant {
  Public = 'PUBLIC'
}

export type VendingExport = {
  entries: Array<VendingExportEntry>;
};

export type VendingExportEntry = {
  brand: Brand;
  instantBuy: InstantBuy;
  organization: Organization;
  priceAmount: Scalars['Int']['output'];
  product: Product;
  purchasedAt: Scalars['DateTime']['output'];
  reservation: VendingReservation;
};

export type VendingExportFilter = {
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};

export type VendingReservation = Reservation & {
  activeProductInstance?: Maybe<ProductInstance>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  flex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  instantBuys: InstantBuyPage;
  lineItemsCount: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  productInstancesCount: Scalars['Int']['output'];
  service: Service;
  space: Space;
  unlockRequests: UnlockRequestPage;
};


export type VendingReservationInstantBuysArgs = {
  filter?: InputMaybe<InstantBuyFilter>;
  orderBy?: Array<InstantBuyOrderByEntry>;
  pagination?: PaginationInput;
};


export type VendingReservationUnlockRequestsArgs = {
  filter?: InputMaybe<UnlockRequestFilter>;
  orderBy?: Array<UnlockRequestOrderByEntry>;
  pagination?: PaginationInput;
};

export type VendingReservationCreateInput = {
  spaceId: Scalars['UUID']['input'];
};

export type Warehouse = {
  additionalInfo?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  hubs: Array<Hub>;
  id: Scalars['UUID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type WarehouseCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type WarehouseFilter = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type WarehouseHubInput = {
  hubId: Scalars['UUID']['input'];
  warehouseId: Scalars['UUID']['input'];
};

export type WarehouseOrderByEntry = {
  field: WarehouseOrderByField;
  ordering: Ordering;
};

export enum WarehouseOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

export type WarehousePage = {
  nodes: Array<Warehouse>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type WarehouseUpdateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The warehouse's owning organization, not a reassignment target. */
  organizationId: Scalars['UUID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}
